import leastIndex from "./leastIndex.js";

export default function scan(values, compare) {
  const index = leastIndex(values, compare);
  return index < 0 ? undefined : index;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-scale/node_modules/d3-array/src/scan.js
// module id = 1720
// module chunks = 0